import * as React from 'react'
import { Theme, Typography } from '@web-apps/ui-shared'
import { useTranslation } from 'next-i18next'
import { Line as LineProgress } from 'rc-progress'

import { LoadingScreenSlideType } from '../../types'
import {
  StyledLoaderWrapper,
  StyledProgressBarContainer,
  StyledSplashContainer,
  StyledSplashSlideContainer,
  StyledSplashSlideGradient,
  StyledSplashTextContainer,
} from './SplashScreen.styles'

type Props = {
  slide: LoadingScreenSlideType
  percentage: number
}

const PROGRESS_LINE_HEIGHT_RATIO = 7

export const SplashScreen = ({ slide, percentage }: Props) => {
  const { t } = useTranslation(['pages', 'common'])

  const SlideImageSVGComponent = slide.SVGComponent

  return (
    <StyledLoaderWrapper>
      <StyledSplashContainer>
        <StyledSplashSlideContainer>
          <StyledSplashSlideGradient />
          <SlideImageSVGComponent />
          <StyledSplashTextContainer>
            <Typography variant="h1" as="h2">
              {t(`pages:${slide.titleKey}`)}
            </Typography>
            <Typography>{t(`pages:${slide.descriptionKey}`)}</Typography>
          </StyledSplashTextContainer>
        </StyledSplashSlideContainer>

        <StyledProgressBarContainer>
          <LineProgress
            percent={percentage}
            strokeWidth={PROGRESS_LINE_HEIGHT_RATIO}
            trailWidth={PROGRESS_LINE_HEIGHT_RATIO}
            trailColor={Theme.Colors.background.inactive}
            strokeColor={Theme.Colors.typography.regular}
          />
        </StyledProgressBarContainer>
      </StyledSplashContainer>
    </StyledLoaderWrapper>
  )
}
